import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { AllocateTeacher } from './AllocateTeacher';
import { GroupDetail } from './GroupDetail';
import { GroupList } from './GroupList';
import { SkuList } from './skuList';

export const Group = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/skus/:from`} component={SkuList} />
    <Route path={`${props.match.path}/sku/:skuId/grouplist`} component={GroupList} />
    <Route path={`${props.match.path}/allocateTeacher/:skuId`} component={AllocateTeacher} />
    <Route path={`${props.match.path}/sku/:skuId/group/:id`} component={GroupDetail} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/group/Group.tsx